import { signalStore, withState, type, withProps, withMethods, patchState } from '@ngrx/signals';
import { event, Events, withEventHandlers } from '@ngrx/signals/events';
import { createdMangel } from '../mangelerfassungsdialog/mangeldialog.component';
import { inject } from '@angular/core';
import { APIService } from 'src/app/services/APIService/api.service';
import { filter, mergeMap } from 'rxjs';
import { errorHandle } from 'src/app/misc/functions';
import { ToastService } from 'src/app/services/toast.service';
import { MrTranslatePipe } from 'src/app/pipes/mr-translate.pipe';
import { Row } from 'src/app/models/ui/table';

export const savedToAuftrag = event('[Auftrag API] Saved Mangel to Auftrag', type<void>());

export const AuftragMangelStore = signalStore(
  { providedIn: 'root' },
  withState({
    auftragId: null as number,
    kauftsId: null as number,
    maengel: [] as Row[],
  }),
  withProps(_ => ({
    events: inject(Events),
    api: inject(APIService),
    toastr: inject(ToastService),
    mrTranslate: inject(MrTranslatePipe),
  })),
  withEventHandlers(({ auftragId, kauftsId, events, api, mrTranslate, toastr }) => ({
    assignMangelToAuftrag$: events.on(createdMangel).pipe(
      filter(() => auftragId() !== null && kauftsId() !== null),
      mergeMap(async ({ payload: { omazsid } }) => {
        try {
          await api.updateMangelAuftrag(omazsid, auftragId(), kauftsId());
          toastr.success(mrTranslate.transform('Mangel wurde zum Auftrag hinzugefügt'));
          return savedToAuftrag();
        } catch (er) {
          toastr.error(errorHandle(er));
        }
      })
    ),
  })),
  withMethods(store => ({
    openedAuftrag(auftragId: number) {
      patchState(store, { auftragId });
    },
    openedMangelErfassung(kauftsId: number) {
      patchState(store, { kauftsId });
    },
    saveReloadedMangel(maengel: Row[]) {
      patchState(store, { maengel });
    },
  }))
);
